
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/readability",
      function () {
        return require("private-next-pages/readability.tsx");
      }
    ]);
  